// @flow
import React from "react";
import type { IconProps } from "../";

type Props = {
  ...IconProps,
  className?: string,
  onClick?: () => void
};

export default function PushSubscription({ width = "56px", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 65"
      width={width}
      {...props}
    >
      <g transform="translate(-33.6)">
        <path
          fill="#ff7900"
          d="M180.8,476a16.57,16.57,0,0,0,8.918,3.021A15.485,15.485,0,0,0,198.637,476Z"
          transform="translate(-128.119 -414.021)"
        />
        <path
          id="SVGCleanerId_0"
          fill="#ffb000"
          d="M87.526,137.492H85.037c0-1.042-.207-.625-.207-.833,0-9.375-6.637.1-8.711-22.4V110.2A14.688,14.688,0,0,0,61.6,95.2c-8.193,0-14.519,6.667-14.519,15v4.063c-2.074,22.6-8.711,13.021-8.711,22.5,0,.208-.207-.208-.207.833H35.674c-1.244,0-2.074.521-2.074,1.771v1.562c0,1.146.83,1.771,2.074,1.771H87.526c1.244,0,2.074-.625,2.074-1.875v-1.562C89.6,138.012,88.77,137.492,87.526,137.492Z"
          transform="translate(0 -82.804)"
        />
        <g transform="translate(33.6 12.396)">
          <path
            id="SVGCleanerId_0_1_"
            fill="#ffb000"
            d="M87.526,137.492H85.037c0-1.042-.207-.625-.207-.833,0-9.375-6.637.1-8.711-22.4V110.2A14.688,14.688,0,0,0,61.6,95.2c-8.193,0-14.519,6.667-14.519,15v4.063c-2.074,22.6-8.711,13.021-8.711,22.5,0,.208-.207-.208-.207.833H35.674c-1.244,0-2.074.521-2.074,1.771v1.562c0,1.146.83,1.771,2.074,1.771H87.526c1.244,0,2.074-.625,2.074-1.875v-1.562C89.6,138.012,88.77,137.492,87.526,137.492Z"
            transform="translate(-33.6 -95.2)"
          />
        </g>
        <path
          fill="#ffb000"
          d="M198.074,15.417a7.708,7.708,0,1,1,7.674-7.708A7.674,7.674,0,0,1,198.074,15.417Zm0-12.292a4.583,4.583,0,1,0,4.563,4.583A4.614,4.614,0,0,0,198.074,3.125Z"
          transform="translate(-136.474)"
        />
        <g transform="translate(39.304)">
          <path
            fill="#ffc200"
            d="M85.378,113.567C83.3,131.067,79.57,129.088,77.6,131.8c15.037-.833,26.237-12.083,26.859-25.833a94.268,94.268,0,0,0,0-10.833A15.266,15.266,0,0,0,100.1,94.4a14.8,14.8,0,0,0-14.726,15Z"
            transform="translate(-77.6 -82.108)"
          />
          <path
            fill="#ffc200"
            d="M205.541,6.146a7.655,7.655,0,1,0-10.474,8.646A12.289,12.289,0,0,0,205.541,6.146Zm-7.467-3.021a4.583,4.583,0,1,1-4.563,4.583A4.614,4.614,0,0,1,198.074,3.125Z"
            transform="translate(-175.778)"
          />
        </g>
        <path
          fill="#e83821"
          d="M284.563,269.5a9.537,9.537,0,0,1-9.541,9.583h-7.882A9.537,9.537,0,0,1,257.6,269.5v-7.917A9.537,9.537,0,0,1,267.141,252h7.882a9.537,9.537,0,0,1,9.541,9.583Z"
          transform="translate(-194.963 -219.187)"
        />
        <path
          fill="#f63f27"
          d="M257.6,261.482A9.457,9.457,0,0,1,267.082,252h8.039c5.257,0,9.276,4.638,9.276,9.895v7.524a9.457,9.457,0,0,1-9.482,9.482"
          transform="translate(-194.963 -219.187)"
        />
        <path
          fill="#fff"
          d="M336.776,312.9a5.759,5.759,0,0,0-3.007-.521l.207-1.25h3.941c.415,0,.415-.833.415-1.25v-1.354c0-.417,0-.521-.415-.521h-5.807c-.415,0-.726.208-.726.521l-.726,5.729a.9.9,0,0,0,.311.625.872.872,0,0,0,.726.208c.415,0,.83-.1,1.452-.1,1.763,0,2.7.625,2.7,1.875a1.91,1.91,0,0,1-2.074,1.875,4.714,4.714,0,0,1-2.178-.521,1.31,1.31,0,0,0-.622-.1c-.207.1-.415.208-.415.521l-.415,1.25a.842.842,0,0,0,.311.938,6.539,6.539,0,0,0,3.422.833,4.7,4.7,0,0,0,2.9-8.75Z"
          transform="translate(-258.065 -267.896)"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Announcements/PushSubscription.js